import { render, staticRenderFns } from "./3introduce.vue?vue&type=template&id=c616e9b8&scoped=true&"
import script from "./3introduce.vue?vue&type=script&lang=js&"
export * from "./3introduce.vue?vue&type=script&lang=js&"
import style0 from "./3introduce.vue?vue&type=style&index=0&id=c616e9b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c616e9b8",
  null
  
)

export default component.exports